import { render, staticRenderFns } from "./ExportAries.vue?vue&type=template&id=3bac1136"
import script from "./ExportAries.vue?vue&type=script&lang=js"
export * from "./ExportAries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports